import React from 'react'
import { motion } from 'framer-motion'

import finalnoteImage from '../../../assets/images/tatvacare/tatvacarfootercard.webp'
import noteIcon from '../../../assets/images/tatvacare/finalnote.webp'

const FinalNote = () => {
  return (
    <section className="w-full py-10">

      <div className="relative flex min-h-[180px] w-full items-center justify-center overflow-hidden md:min-h-[250px] lg:min-h-[280px] xl:min-h-[300px] 2xl:min-h-[320px]">

        {/* Background */}
        <img
          src={finalnoteImage}
          alt="Final Note Background"
          className="absolute inset-0 h-full w-full object-container"
        />

        {/* Content */}
        <motion.div
          initial={{
            opacity: 0,
            scale: 0.75,
          }}
          whileInView={{
            opacity: 1,
            scale: 1,
          }}
          viewport={{
            once: false,
            amount: 0.4,
          }}
          transition={{
            duration: 0.7,
            ease: 'easeOut',
          }}
          className="relative z-10 flex w-full max-w-[1100px] flex-col items-center justify-center px-6 text-center md:px-10"
        >

          {/* Icon + Heading */}
          {/* <div className="flex items-center gap-3 md:gap-5">

            <img
              src={noteIcon}
              alt="Final note icon"
              className="h-8 w-8 shrink-0 md:h-10 md:w-10 lg:h-12 lg:w-12"
            />

            <h2 className="font-gilroy-bold text-2xl text-white md:text-4xl xl:text-5xl">
              Final Note
            </h2>

          </div> */}

          {/* Paragraph */}
          <motion.p
            initial={{
              opacity: 0,
              scale: 0.9,
            }}
            whileInView={{
              opacity: 1,
              scale: 1,
            }}
            viewport={{
              once: false,
              amount: 0.5,
            }}
            transition={{
              duration: 0.8,
              delay: 0.15,
              ease: 'easeOut',
            }}
            className="mt-2 max-w-[1050px] font-gilroy-medium text-sm leading-[1.6] text-white/90 md:mt-6 md:text-xl lg:text-2xl"
          >
            Tattva Care isn’t just a tool—it’s a step toward intelligent,
            accessible, and trustworthy digital healthcare, where doctors can
            focus more on patients and less on searching for answers.
          </motion.p>

        </motion.div>

      </div>

    </section>
  )
}

export default FinalNote